// The timezones a school can pick, east to west. Mirrors
// School::TIMEZONES; labels name the zone the way people say it.
export const TIMEZONES = [
  { value: "America/St_Johns", label: "Newfoundland (St. John's)" },
  { value: "America/Halifax", label: "Atlantic (Halifax)" },
  { value: "America/Toronto", label: "Eastern (Toronto)" },
  { value: "America/Winnipeg", label: "Central (Winnipeg)" },
  { value: "America/Regina", label: "Saskatchewan (Regina)" },
  { value: "America/Edmonton", label: "Mountain (Edmonton)" },
  { value: "America/Whitehorse", label: "Yukon (Whitehorse)" },
  { value: "America/Vancouver", label: "Pacific (Vancouver)" },
];

export function timezoneLabel(value) {
  return TIMEZONES.find((tz) => tz.value === value)?.label || value?.replace("America/", "").replace("_", " ");
}

// Where most of each province's schools are. Mirrors
// School::DEFAULT_TIMEZONE_BY_PROVINCE.
const PROVINCE_TIMEZONES = {
  AB: "America/Edmonton", BC: "America/Vancouver", MB: "America/Winnipeg",
  NB: "America/Halifax", NL: "America/St_Johns", NS: "America/Halifax",
  NT: "America/Edmonton", NU: "America/Toronto", ON: "America/Toronto",
  PE: "America/Halifax", QC: "America/Toronto", SK: "America/Regina",
  YT: "America/Whitehorse",
};

export function suggestedTimezone(province) {
  return PROVINCE_TIMEZONES[province] || "America/Toronto";
}

// "Sat 2:14 PM" in the given zone, for a "does this match your clock?" check.
export function localTimeIn(timezone, now = new Date()) {
  try {
    return now.toLocaleString("en-CA", { timeZone: timezone, weekday: "short", hour: "numeric", minute: "2-digit" });
  } catch {
    return null;
  }
}
